export const ProductType = {
    CATEGORY: "CATEGORY",
    BRAND: "BRAND",
    PRODUCT: "PRODUCT"
};

export const ShoppingProcessType = {
    CART: 1,
    ORDER: 2,
    ORDER_COMPLETE: 3
}

export const CategorySpecType = {
    TEXT: "TEXT",
    NUMBER: "NUMBER",
    FLOAT: "FLOAT"
}

export const ProductThumbnailType = {
    IMAGE : "IMAGE", 
    VIDEO : "VIDEO"
}